/* eslint-disable */
import React, { useLayoutEffect } from "react";
import { termcoverageBrochure, ManhattanLifeLogo } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBtermcoverageImage from "../../../../../assets/VEBPlanImages/termcoverageImage.avif";

import "./termlifecoverage.scss";

const TermcoveragePlan: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	}, []); // ✅ Added dependency array

	return (
		<div className="termcoverage-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Term Life Coverage</h3>

					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={ManhattanLifeLogo} alt="Manhattan Life Logo" />
					</div>

					<div className="plan-description">
						<span>
							If someone depends financially on you, you need life insurance, whether you are married,
							single, a single parent, a small-business owner, or retired. With life insurance, you can
							spare your grieving loved ones the additional stress of economic difficulties, preserving
							their quality of life even after your death.
						</span>

						<h3>Stay focused on getting well</h3>

						<span>
							ManhattanLife Term Coverage offers you the advantage of affordable group rates through your
							employer, easy payroll deductions, and popular features like guaranteed issue and
							portability—plus optional coverage for your spouse and children.
						</span>
					</div>
				</div>

				<div className="right-section">
					<img src={VEBtermcoverageImage} alt="Term Coverage Plan" />
				</div>
			</div>

			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={termcoverageBrochure} />
			</div>
		</div>
	);
};

export default TermcoveragePlan; //
